import { configureStore } from '@reduxjs/toolkit'
import counterReducer from '../reducers/userReducer'

export const store = configureStore({
  reducer: {
    counter: counterReducer,
  },
})